import React, { Component } from "react";
import { Link } from "react-router-dom";
class CityXTeam_SideBar extends Component {
  render() {
    return (
      <div id="sidebar">
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={0}
          data-smobile={0}
        />
        <div id="inner-sidebar" className="inner-content-wrap">
          <div className="widget widget_list">
            <div className="inner">
              <ul className="list-wrap">
                <li className="list-item">
                  <Link
                    to="/about/startups"
                    onClick={() => {
                      window.location.href = "/about/carees";
                    }}
                  >
                    <span className="text">Otvorena radna mjesta</span>
                  </Link>
                </li>
                <li className="list-item">
                  <Link
                    to="/about/startups"
                    onClick={() => {
                      window.location.href = "/about/remote-work";
                    }}
                  >
                    <span className="text">Zašto odabrati startup?</span>
                  </Link>
                </li>
                <li className="list-item">
                  <a href="/news-list-media">
                    <span className="text">CityX u medijima</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={0}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    );
  }
}

export default CityXTeam_SideBar;
